import React from "react";

interface PillProps {
  children: React.ReactNode;
  variant?: "warning" | "completed" | "info" | "default" | "error" | "primary";
  noMargin?: boolean;
}

// This is known as the Elements->Badge component in Figma.
const Pill = ({ children, variant = "completed", noMargin = false }: PillProps) => {
  // at the moment, these colors are not in our color palette, so we can replace this once we get yellow and green palettes
  const variantStyles = {
    warning: "bg-[#FEF3C7] text-[#92400E]",
    completed: "bg-[#D1FAE5] text-[#065F46]",
    info: "bg-[#DBEAFE] text-[#1E40AF]",
    default: "bg-[#F5F4F9] text-[#332E42]",
    error: "bg-[#FFE2E5] text-[#991B1B]",
    primary: "bg-primary-100 text-primary-700",
  };

  return (
    <span
      className={`
      inline-block px-2.5 py-0.5 rounded-[10px]
      text-xs font-medium leading-4 ${noMargin ? "" : "ml-2"}
      ${variantStyles[variant]}
    `}
    >
      {children}
    </span>
  );
};

export default Pill;
